import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eeb4c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-pt-0 tw-p-10 tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[3px] tw-h-[3px] tw-bg-[#231F20] tw-rounded-[100%] tw-m-[9.3px]" }, null, -1))
const _hoisted_6 = { class: "tw-flex-1" }
const _hoisted_7 = { class: "tw-flex tw-justify-end tw-mt-10" }

import ModalHeader from "../../components/common/modalHeader.vue";
import { getComponentUiText } from "../../utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../../components/common/modalComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalDomainNotBelongToOrg',
  props: {
  listDomains: {
    type: Array as () => Array<any>,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  emits: [
  "update:show",
  "update:domain-data",
  "update:domain-close",
],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);


const handleCloseModal = () => {
  emit("update:domain-close");
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleUpdateModal = (isAdd) => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:domain-data", isAdd);
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  overflow: "unset",
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 38,
    "style-class-contain": styleClassContain
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": `no__header`,
        style: {"z-index":"10"},
        title: "",
        onClose: handleCloseModal
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-description-1",
            )), 1),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listDomains, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "tw-flex"
              }, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(item), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", null, _toDisplayString(__props.listDomains && __props.listDomains.length > 1
              ? _unref(getComponentUiText)(
                  "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domains-sub-description-1",
                )
              : _unref(getComponentUiText)(
                  "app-menu-submenu-settings-setup-wizard-modal-webfacing-not-belong-to-domain-sub-description-1",
                )), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: _normalizeClass(["tw-border-[#F7553C] tw-mr-[15px] tw-bg-[#F7553C] hover:!tw-bg-[#c82333] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-rounded-[27px] tw-h-[39px] tw-leading-[100%] tw-font-medium", ['tw-text-white']]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleUpdateModal(false)))
            }, _toDisplayString(_unref(getComponentUiText)(
                "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
              )), 1)
          ]),
          _createVNode(_component_b_button, {
            style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
            variant: "primary",
            class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
            type: "submit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleUpdateModal(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
            )), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})